import { createContext, useContext, useState, type ReactNode } from "react";

interface MockDataContextType {
  isMockMode: boolean;
  setMockMode: (value: boolean) => void;
}

const MockDataContext = createContext<MockDataContextType | undefined>(undefined);

interface MockDataProviderProps {
  children: ReactNode;
}

export function MockDataProvider({ children }: MockDataProviderProps) {
  const [isMockMode, setMockMode] = useState(false);

  return (
    <MockDataContext.Provider value={{ isMockMode, setMockMode }}>
      {children}
    </MockDataContext.Provider>
  );
}

export function useMockData() {
  const context = useContext(MockDataContext);
  if (!context) {
    throw new Error("useMockData must be used within MockDataProvider");
  }
  return context;
}
